






































































































import { Component, Prop, Vue } from "vue-property-decorator";
//  utilities
import dateHelper from "Utilities/date-helper";
import moment from "moment";

@Component({})
export default class DataQualityIndicator extends Vue {
  @Prop({ type: Number, default: 0 }) showOverallStatus!: Number;
  @Prop({ type: Boolean, default: false }) withText!: boolean;
  @Prop({ type: String, default: "" }) columnName!: string;
  @Prop({ type: String, default: "" }) link?: string;
  @Prop({ type: String, default: null }) lastDataTimestamp?: string | null;
  @Prop({ type: String, default: null }) outageStartTime?: string | null;

  //  @Getters
  get isOverallStatusColumn(): boolean {
    return this.columnName === "Overall Status";
  }

  get status(): string {
    switch (this.showOverallStatus) {
      case 1:
        return "Available";
      case 2:
        return "Observe";
      case 3:
        return "Alert";
      default:
        return "N/A";
    }
  }

  //  @Methods
  navigateToLink(): void {
    if (this.link === undefined) {
      throw new Error("Link is undefined");
    }
    this.$router.push(this.link);
  }

  getFormatedDateTimeString(timestamp: string): string {
    return dateHelper.getFormatedDateTimeString(timestamp);
  }

  duration(timestamp: string): string {
    return dateHelper.getHumanizeDuration(timestamp, moment().valueOf());
  }
}
